import _ from "lodash";
import React from "react";
import classNames from "classnames";
import { getStyleStrippedText } from "./htmlSanitize";
import { Tooltip } from "@toddle-edu/ds-web";
import { InformationOutlined } from "@toddle-edu/ds-icons";

import ACLStore from "lib/aclStore";

const DESCRIPTION_SUPPORTED_PLANNER_ELEMENT = [
  "MYP_LEARNING_STANDARD",
  "UBD_LEARNING_STANDARD",
  "DP_SUBJECT_STANDARD",
  "BENCHMARK",
  "LEARNING_OUTCOME",
];

export const getSubjectStandardWithCode = ({
  label,
  code,
  labelClass,
  codeClass,
  containerClass,
  subText,
  shouldDangerouslyInjectLabel = true,
  type,
}) => {
  const shouldShowDescriptionIcon =
    ACLStore.can("FeatureFlag:EnableDescriptionInSNS") &&
    subText &&
    _.includes(DESCRIPTION_SUPPORTED_PLANNER_ELEMENT, type);
  const codeLabelClasses = classNames("text-textSubtle", {
    [codeClass]: codeClass,
  });

  const standardLabelClasses = classNames({
    [labelClass]: labelClass,
  });

  const containerClasses = classNames({
    [containerClass]: containerClass,
  });

  return (
    <span className={containerClasses}>
      {shouldDangerouslyInjectLabel ? (
        <span
          className={standardLabelClasses}
          dangerouslySetInnerHTML={{
            __html: getStyleStrippedText({ text: label, type: "SNS_EDITOR" }),
          }}
        />
      ) : (
        label
      )}
      {code ? (
        <span
          className={codeLabelClasses}
          style={{ fontStyle: "italic" }}
          dangerouslySetInnerHTML={{
            __html: getStyleStrippedText({
              text: ` (${code})`,
              type: "SNS_EDITOR",
            }),
          }}
        />
      ) : null}
      {shouldShowDescriptionIcon && (
        <span style={{ marginLeft: "4px", verticalAlign: "middle" }}>
          <Tooltip tooltip={subText} overlayInnerStyle={{ maxWidth: "344px" }}>
            <InformationOutlined
              size="xxx-small"
              variant="subtle"
              style={{ marginTop: "3px" }}
            />
          </Tooltip>
        </span>
      )}
    </span>
  );
};
